import { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
  Tooltip,
} from '@mui/material';
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Dashboard as DashboardIcon,
  Description as DescriptionIcon,
  AttachMoney as AttachMoneyIcon,
  Notifications as NotificationsIcon,
  People as PeopleIcon,
  Person as PersonIcon,
  Assessment as AssessmentIcon,
  LocalShipping as TruckIcon,
  Business as BusinessIcon,
  DriveFolderUpload as UploadIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { NAVBAR_HEIGHT } from './NavBar';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'; // Ajoute cette ligne pour l'icône facture

export const SIDEBAR_WIDTH = 240;
export const SIDEBAR_COLLAPSED_WIDTH = 60;

export default function SideBar() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const menuItems = [
    { label: 'Tableau de bord', path: '/dashboard', icon: <DashboardIcon /> },
    { label: 'Chauffeurs', path: '/drivers', icon: <PersonIcon /> },
    { label: 'Camions', path: '/trucks', icon: <TruckIcon /> },
    { label: 'Compagnies', path: '/companies', icon: <BusinessIcon /> },
    { label: 'Courses', path: '/trips', icon: <AssessmentIcon /> },
    {
      label: 'Dépenses (globales)',
      path: '/expenses',
      icon: <AttachMoneyIcon />,
    },
    {
      label: 'Dépenses (courses)',
      path: '/trip-expenses',
      icon: <AttachMoneyIcon />,
    },
    // { label: 'Import Courses', path: '/import-trips', icon: <UploadIcon /> },
    // { label: 'Import Dépenses', path: '/import-expenses', icon: <UploadIcon /> },
    { label: 'Rapports', path: '/trip-reports', icon: <AssessmentIcon /> },
    { label: 'Finances', path: '/financials', icon: <AssessmentIcon /> },
    {
      label: 'Notifications',
      path: '/notifications',
      icon: <NotificationsIcon />,
    },
    { label: 'Tickets', path: '/tickets', icon: <AssessmentIcon /> },
    { label: 'Factures', path: '/factures', icon: <ReceiptLongIcon /> },
    { label: 'Kilométrage', path: '/mileages', icon: <AssessmentIcon /> },
  ];

  const handleToggle = () => {
    setOpen(!open);
  };

  if (!user) return null;

  return (
    <>
      {isMobile && (
        <IconButton
          onClick={handleToggle}
          sx={{
            position: 'fixed',
            top: NAVBAR_HEIGHT + 8,
            left: 16,
            zIndex: theme.zIndex.drawer - 1,
            bgcolor: 'primary.main',
            color: 'white',
            '&:hover': {
              bgcolor: 'primary.dark',
            },
          }}
        >
          <MenuIcon />
        </IconButton>
      )}
      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? open : true}
        onClose={isMobile ? handleToggle : undefined}
        sx={{
          width: open ? SIDEBAR_WIDTH : SIDEBAR_COLLAPSED_WIDTH,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: open ? SIDEBAR_WIDTH : SIDEBAR_COLLAPSED_WIDTH,
            boxSizing: 'border-box',
            bgcolor: 'primary.main',
            color: 'white',
            transition: 'width 0.3s ease-in-out',
            overflowX: 'hidden',
            borderRight: 'none',
            boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
            marginTop: `${NAVBAR_HEIGHT}px`,
            height: `calc(100% - ${NAVBAR_HEIGHT}px)`,
            position: 'fixed',
          },
        }}
      >
        <Box
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid rgba(255,255,255,0.1)',
          }}
        >
          {open && (
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Menu
            </Typography>
          )}
          <Tooltip title={open ? 'Réduire' : 'Développer'} placement="right">
            <IconButton
              onClick={handleToggle}
              sx={{
                color: 'white',
                transition: 'transform 0.3s ease-in-out',
                transform: open ? 'rotate(0deg)' : 'rotate(180deg)',
              }}
            >
              {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </Tooltip>
        </Box>
        <List>
          {menuItems.map((item) => (
            <ListItem
              key={item.label}
              onClick={() => navigate(item.path)}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  bgcolor: 'primary.dark',
                  transition: 'background-color 0.2s ease-in-out',
                },
                py: 1.5,
                px: open ? 2 : 1,
                transition: 'padding 0.3s ease-in-out',
                justifyContent: open ? 'flex-start' : 'center',
              }}
            >
              <ListItemIcon
                sx={{
                  color: 'white',
                  minWidth: 40,
                  transition: 'all 0.3s ease-in-out',
                }}
              >
                {item.icon}
              </ListItemIcon>
              {open && (
                <ListItemText
                  primary={item.label}
                  sx={{
                    '& .MuiTypography-root': {
                      fontSize: '0.95rem',
                      fontWeight: 500,
                    },
                  }}
                />
              )}
            </ListItem>
          ))}
        </List>
      </Drawer>
      {!isMobile && (
        <Box sx={{ width: open ? SIDEBAR_WIDTH : SIDEBAR_COLLAPSED_WIDTH }} />
      )}
    </>
  );
}
